import { createFileRoute } from "@tanstack/react-router";
import { ExpoMigrationPage } from "@/components/blocks/pages/ExpoMigrationPage";
import { getTranslator } from "@/lib/i18n";
import { resolveLocaleForPath } from "@/lib/i18n/locale";
import { buildSeo } from "@/lib/seo";

export const Route = createFileRoute("/{-$locale}/expo-migration")({
	component: ExpoMigrationPage,
	loader: ({ location, serverContext }) => ({
		locale: resolveLocaleForPath(location.pathname, serverContext),
	}),
	head: ({ loaderData }) => {
		if (!loaderData) return {};
		const t = getTranslator(loaderData.locale);
		return buildSeo({
			title: t((t) => t.seo.expoMigrationTitle),
			description: t((t) => t.seo.expoMigrationDescription),
			path: "/expo-migration",
			locale: loaderData.locale,
		});
	},
});
